import React, { type JSX } from 'react';

import { AccordionDetails, Box, List, ListItem, Stack, Typography } from '@mui/material';

// Pure module-level helpers — keep decision points out of the map callback

const hasValue = (item: any): boolean =>
    Boolean(item) && (String(item.value ?? '').trim() !== '' || String(item.unit ?? '').trim() !== '');

const renderChannelValue = (
    isActive: boolean,
    value: string,
    unit: string,
    listClassName = 'delayed-input-class channel-value-textfield flex-46'
): JSX.Element => (
    <List
        sx={{ width: 132, bgcolor: 'action.hover', borderRadius: 1, px: 1, py: 0.5, cursor: 'default' }}
        className={listClassName}
    >
        <ListItem disableGutters sx={{ px: 0 }}>
            <Stack direction="row" justifyContent="flex-end" width="100%">
                <Typography variant="body2" sx={{ ...(!isActive && { ml: 0.5, opacity: 0.8 }) }}>
                    {isActive ? value : 'N/A'}
                </Typography>
                <Typography variant="body2" sx={{ ml: 0.5, opacity: 0.8 }}>
                    {isActive ? unit : ''}
                </Typography>
            </Stack>
        </ListItem>
    </List>
);

export const EventSummaryDetails = ({ events, category }: { events: any; category: any }): JSX.Element => (
    <AccordionDetails className="padding-0">
        {events?.data['alarmOccurred']?.[category]?.map((channel: any) => {
            const alarmUpdatedDetails = events?.data?.['alarmUpdated']?.[category]?.find(
                (subChannel: any) => subChannel.channelId === channel.channelId
            );
            const isAlarmUpdates = hasValue(alarmUpdatedDetails);
            const isChannelDetails = hasValue(channel);
            return (
                <Stack
                    key={channel?.channelId}
                    direction={'row'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    className="flex-100 border-bottom-1"
                    pl={2}
                    py={1}
                >
                    <Stack direction={'row'} alignItems={'center'} className="flex-30" spacing={1}>
                        <Box className="border-radius-50 width-24 height-24 bg-content" />
                        <Typography variant="body2" fontSize={'14px'}>
                            {channel?.displayName ?? '-'}
                        </Typography>
                    </Stack>
                    <Stack direction="row" className="flex-60" spacing={1}>
                        {renderChannelValue(
                            isChannelDetails,
                            channel?.value,
                            channel?.unit,
                            'delayed-input-class channel-value-textfield flex-46 default-cursor'
                        )}
                        {renderChannelValue(isAlarmUpdates, alarmUpdatedDetails?.value, alarmUpdatedDetails?.unit)}
                    </Stack>
                </Stack>
            );
        })}
    </AccordionDetails>
);
